import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { switchMap, catchError, throwError, take } from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(SocialAuthService);

  return authService.authState.pipe(
    take(1),
    switchMap((user: SocialUser | null) => {
      if (!user?.idToken || req.url.includes('amazonaws.com')) return next(req);
      const request = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${user.idToken}`),
      });
      return next(request)
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 ) {
        authService.signOut();
      }
      return throwError(() => error);
    })
  );
};
